module.exports = __webpack_public_path__ + "static/shuffleIcon-5c1d48b6ad83dcaf5befeca8742b9556.png";